export default {"src":"/_next/static/media/csb.1bc6760a.svg","height":598,"width":569,"blurWidth":0,"blurHeight":0};